import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';
import { FormStatuses } from 'types/formService';

interface StatusLabelStylings {
  $status: FormStatuses;
}

export const StatusLabelStyled = styled.p<StatusLabelStylings>`
  color: ${colors.green[600]};
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  ${({ $status }): CSSProp => {
    switch ($status) {
      case FormStatuses.COMPLETE:
        return css`
          color: ${colors.green[600]};
        `;
      case FormStatuses.STARTED:
        return css`
          color: ${colors.orange[600]};
        `;
      default:
        return css`
          color: ${colors.neutral[900]};
        `;
    }
  }}
`;

export const CardStatusTextStyled = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const ActionButtonStyled = styled(Button)`
  margin: 0 auto;
`;
